import React from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import SlickArrow from './SlickArrow';

/**
 * SlickWrapper.
 *
 * Rendered when the Route matches /watch
 */
class SlickWrapper extends React.PureComponent {
    slickGoTo(index) {
        this.slider.slickGoTo(index);
    }

    render() {
        const {props} = this;
        const {options} = props;
        if (props.children.length < options.slidesToShow) {
            options.infinite = false;
        }
        if (props.children.length === 1) {
            return (
                <div>
                    {props.children}
                </div>
            );
        }
        const carouselItems = [];
        for (const child of props.children) {
            carouselItems.push(
                <div key={child.key}>
                    {child}
                </div>
            );
        }
        return (
            <Slider
                ref={(c) => {this.slider = c;}} className={this.props.className}
                nextArrow={<SlickArrow />} prevArrow={<SlickArrow />}
                {...options}>
                {carouselItems}
            </Slider>
        );
    }
}

SlickWrapper.propTypes = {
    children: PropTypes.node,
    options: PropTypes.object,
    className: PropTypes.string
};

export default SlickWrapper;
